import styled from 'styled-components'

export const Wrapper = styled.main`
  width: 100%;
  max-width: 380px;
  display: flex;
  align-items: center;
  flex-direction: column;

  button {
    width: 90%;
    height: 50px;
    border: none;
    background: linear-gradient(
      178.59deg,
      #ff5f5f -14.51%,
      #f062c0 102.86%,
      #f23131 102.86%
    );
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
  }
`
